import { render, staticRenderFns } from "./WhatsAppAlertsPage.vue?vue&type=template&id=40f9ccda&scoped=true"
import script from "./WhatsAppAlertsPage.vue?vue&type=script&lang=js"
export * from "./WhatsAppAlertsPage.vue?vue&type=script&lang=js"
import style0 from "./WhatsAppAlertsPage.vue?vue&type=style&index=0&id=40f9ccda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f9ccda",
  null
  
)

export default component.exports